import React from 'react';
import {
  Autocomplete, Box, Divider, FormControl, Grid, InputLabel,
  MenuItem, Select, TextField, Typography
} from '@mui/material';
import FormDialog from '../../common/FormDialog';

const clsName = (c) => c?.name || c?.class_name || 'Class';

const SectionLabel = ({ children }) => (
  <Typography variant="caption" fontWeight={700} color="text.secondary"
    sx={{ textTransform: 'uppercase', letterSpacing: 0.6, display: 'block', mb: 0.5 }}>
    {children}
  </Typography>
);

const BulkEditReportCardsDialog = ({
  open, onClose, onSubmit, saving, isMobile = false,
  selectedCount = 0, form, setForm, allClasses = [],
}) => {
  return (
    <FormDialog
      open={open} onClose={onClose} onSubmit={onSubmit}
      title={`Bulk Edit (${selectedCount} selected)`}
      saving={saving} isMobile={isMobile} maxWidth="sm"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, pt: 1 }}>

        {/* ── 1. Attendance ── */}
        <Box>
          <SectionLabel>1. Attendance</SectionLabel>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth size="small" type="number" label="Days Present"
                value={form.days_present}
                onChange={(e) => setForm((p) => ({ ...p, days_present: e.target.value }))}
                helperText="Leave blank to skip"
                inputProps={{ min: 0 }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth size="small" type="number" label="Days Absent"
                value={form.days_absent}
                onChange={(e) => setForm((p) => ({ ...p, days_absent: e.target.value }))}
                helperText="Leave blank to skip"
                inputProps={{ min: 0 }}
              />
            </Grid>
          </Grid>
        </Box>

        <Divider />

        {/* ── 2. Promotion ── */}
        <Box>
          <SectionLabel>2. Promotion</SectionLabel>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: form.is_promoted === 'true' ? 6 : 12 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Promoted</InputLabel>
                <Select
                  label="Promoted"
                  value={form.is_promoted}
                  onChange={(e) => setForm((p) => ({ ...p, is_promoted: e.target.value, promoted_to_class: '' }))}
                >
                  <MenuItem value="">
                    <em>— Skip —</em>
                  </MenuItem>
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {form.is_promoted === 'true' && (
              <Grid size={{ xs: 12, sm: 6 }}>
                <Autocomplete
                  fullWidth options={allClasses}
                  value={allClasses.find((c) => clsName(c) === form.promoted_to_class) || null}
                  onChange={(_, v) => setForm((p) => ({ ...p, promoted_to_class: v ? clsName(v) : '' }))}
                  getOptionLabel={clsName}
                  isOptionEqualToValue={(o, v) => o.id === v.id}
                  renderInput={(p) => <TextField {...p} label="Promoted To Class" size="small" placeholder="Select class..." />}
                />
              </Grid>
            )}
          </Grid>
        </Box>

      </Box>
    </FormDialog>
  );
};

export default BulkEditReportCardsDialog;
